import ProblemsFilter from '../../models/problem.jsx';

export const problemCategorySelectFields = [
  {id: 0, name: 'All Problem Categories'},
  {id: 'waterClarity', name: 'Water Clarity'},
  {id: 'algae', name: 'Algae'},
  {id: 'surfaceProblems', name: 'Surface Problems'},
  {id: 'chlorineDemand', name: 'Chlorine Demand'},
];

export const problemSelectFields = [
    {id: 0, name: 'general.all'},
    {id: 'cloudy', name: 'general.cloudy'},
    {id: 'hazy', name: 'general.hazy'},
    {id: 'foaming', name: 'preferences.foaming'},

    {id: 'blackAlgae', name: 'general.black.algae'},
    {id: 'greenAlgae', name: 'general.green.algae'},
    {id: 'mustardAlgae', name: 'general.mustard.algae'},
    {id: 'spaAlgae', name: 'general.spa.algae'},
    {id: 'slimeMold', name: 'general.slimemold'},
    {id: 'swampy', name: 'general.swampy'},

    {id: 'copperStaining', name: 'general.copper.staining'},
    {id: 'ironStaining', name: 'general.iron.staining'},
    {id: 'unknownStaining', name: 'general.unknown.staining'},
    {id: 'organicStaining', name: 'general.organic.staining'},
    {id: 'scaleBuildup', name: 'general.scale.buildup'},
    {id: 'waterlineBuildup', name: 'general.waterline.buildup'},

    {id: 'chlorineDemand', name: 'general.chlorine.demand'},
];

export function getProblemModel(state) {
  let pf = new ProblemsFilter({
    waterClarity: state.problemCategory === 'waterClarity',
    cloudy: state.problem === 'cloudy',

    algaeProblems: state.problemCategory === 'algae',
    blackAlgae: state.problem === 'blackAlgae',
    greenAlgae: state.problem === 'greenAlgae',
    mustardAlgae: state.problem === 'mustardAlgae',

    surfaceProblems: state.problemCategory === 'surfaceProblems',
    copperStaining: state.problem === 'copperStaining',
    ironStaining: state.problem === 'ironStaining',
    unknownStaining: state.problem === 'unknownStaining',
    scaleBuildup: state.problem === 'scaleBuildup',
    waterBuildup: state.problem === 'waterBuildup',
    organicStaining: state.problem === 'organicStaining',
    waterlineBuildup: state.problem === 'waterlineBuildup',

    cDDemand: state.problemCategory === 'chlorineDemand',
    chlorineDemand: state.problem === 'chlorineDemand',
    foaming: state.problem === 'foaming',
    hazy: state.problem === 'hazy',
    spaAlgae: state.problem === 'spaAlgae',
    slimeMold: state.problem === 'slimeMold',
    swampy: state.problem === 'swampy',
  });

  return pf.toApiFormat();
}
